export const Stack = ({
  children,
  spacing = 'md',
  className = '',
}: {
  children: React.ReactNode
  className?: string
  spacing?: 'flush' | '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | '7xl'
}) => {
  const findSpacing = () => {
    switch (spacing) {
      case 'flush':
        return 'ap:gap-0'
      case '2xs':
        return 'ap:gap-2xs'
      case 'xs':
        return 'ap:gap-xs'
      case 'sm':
        return 'ap:gap-sm'
      case 'md':
        return 'ap:gap-md'
      case 'lg':
        return 'ap:gap-lg'
      case 'xl':
        return 'ap:gap-xl'
      case '2xl':
        return 'ap:gap-2xl'
      case '3xl':
        return 'ap:gap-3xl'
      case '4xl':
        return 'ap:gap-4xl'
      case '5xl':
        return 'ap:gap-5xl'
      case '6xl':
        return 'ap:gap-6xl'
      case '7xl':
        return 'ap:gap-7xl'

      default:
        return 'ap:gap-lg'
    }
  }
  const space = findSpacing()
  return <div className={`${className} ap:flex ap:flex-col ${space} ap:w-full`}>{children}</div>
}
